import React from 'react';
import './TargetHandle.styl';

export default class TargetHandle extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
  }
  handleMouseDown(e) {
    document.addEventListener('mouseup', this.handleMouseUp);
    document.addEventListener('mousemove', this.handleMouseMove);
  }
  handleMouseMove(e) {
    if (this.el) {
      const rect = this.el.getBoundingClientRect();
      const percentage = Math.round(((e.clientX - rect.x) / rect.width) * 100);
      this.props.onSetTarget(Math.min(100, Math.max(0, percentage)));
    }
  }
  handleMouseUp() {
    document.removeEventListener('mouseup', this.handleMouseUp);
    document.removeEventListener('mousemove', this.handleMouseMove);
  }
  render() {
    return (
      <div className="target-handle-container" ref={ref => (this.el = ref)}>
        <div
          className="target-handle"
          onMouseDown={this.handleMouseDown}
          style={{
            left: `${this.props.percentage}%`,
          }}>
          <div
            className="handle-text"
            style={{
              backgroundColor: this.props.color,
            }}>
            Target {this.props.percentage}%
          </div>
          <div
            className="arrow"
            style={{
              borderTop: '7px solid ' + this.props.color,
            }}
          />
        </div>
      </div>
    );
  }
}
